export enum PortActionError {
  gatewayTimeout = 'ERR_GATEWAY_TIMEOUT',
  inputMismatch = 'ERR_INPUT_MISMATCH',
  invalidPorts = 'ERR_INVALID_PORTS',
  lockedDevice = 'ERR_LOCKED_DEVICE',
  lockedInterfaces = 'ERR_LOCKED_INTERFACES',
  unavailableActionLock = 'ERR_ACTION_LOCK_UNAVAILABLE',
  unsupportedDeviceType = 'ERR_UNSUPPORTED_DEVICE_TYPE',
  unsupportedRegion = 'ERR_UNSUPPORTED_REGION',
}

export const portActionErrorDesc: { [key in PortActionError]: string } = {
  [PortActionError.gatewayTimeout]: 'Gateway Timeout – The server didn\'t respond in time.',
  [PortActionError.inputMismatch]: 'The data you submitted doesn\'t match the device\'s current information about ports.',
  [PortActionError.invalidPorts]: 'Invalid ports submitted — interaction with them is forbidden.',
  [PortActionError.lockedDevice]: 'The current device is being interacted with by another user.',
  [PortActionError.lockedInterfaces]: 'The submitted port(s) are currently locked by another user.',
  [PortActionError.unavailableActionLock]: 'Action lock service unavailable',
  [PortActionError.unsupportedDeviceType]: 'The current device type is unsupported.',
  [PortActionError.unsupportedRegion]: 'The current region is unsupported',
};

export const HMSMaintenance = 'HMS_maintenance';
